import { ReactNode, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { ConditionalRule, FormSection } from '../validations/validations';

import { evaluateCondition } from './conditionalUtils';

interface ConditionalSectionWrapperProps {
  conditional: ConditionalRule;
  section: FormSection;
  children: ReactNode;
}

export default function ConditionalSectionWrapper({
  conditional,
  section,
  children,
}: ConditionalSectionWrapperProps) {
  const { watch, unregister } = useFormContext();
  const parentValue = watch(conditional.field);
  const isVisible = evaluateCondition(conditional, parentValue);

  useEffect(() => {
    if (!isVisible) {
      section.fields.forEach((field) => unregister(field.name));
    }
  }, [isVisible, section.fields, unregister]);

  if (!isVisible) {
    return null;
  }

  return <>{children}</>;
}
